@use '@/styles/tokens' as *;

.textButton {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: auto;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  font-weight: var(--font-weight-medium);
  line-height: 1;
}

// Size variants (applied via the `size` prop → styles[size]).
.sm {
  font-size: 13px;
}

.md {
  font-size: 16px;

  &:disabled {
    color: var(--text-disabled);
    text-decoration: none;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

:global(.ant-btn-link).textButton {
  // Tone colors
  &.default {
    color: var(--text-secondary);

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled),
    &:active:not(:disabled) {
      color: var(--text-secondary);
    }
  }

  &.brand {
    color: $color-brand-600;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled),
    &:active:not(:disabled) {
      color: $color-brand-600;
    }
  }

  &.danger {
    color: $color-error-500;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled),
    &:active:not(:disabled) {
      color: $color-error-500;
    }
  }

  // Link blue for in-table "View" affordances (Figma Info/700).
  &.info {
    color: $color-info-700;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled),
    &:active:not(:disabled) {
      color: $color-info-700;
    }
  }

  // Hover / active overrides
  &:hover:not(:disabled),
  &:focus-visible:not(:disabled) {
    background: transparent;
    text-decoration: underline;
    border: none;
    box-shadow: none;
  }

  &:active:not(:disabled) {
    opacity: 1;
    background: transparent;
    text-decoration: underline;
    border: none;
    box-shadow: none;
  }
}
